import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function destroy(id: number) {
  const response = await http
    .deleteData(`/template/order-penunjang/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  destroy,
}
